import { Span } from "@opentelemetry/sdk-trace-base";

import CONV from "../semantic-conventions";
import { log } from "../utils/logger";
import { getCurrentSessionId, getCurrentUser, getPreviousSessionId } from "./store";

const emitSessionAttributeLog = (
  message: string,
  attributes: Record<string, unknown> = {},
) => {
  log({
    message,
    attributes: {
      "l9rum.session.component": "SessionAttributeInjector",
      ...attributes,
    },
  });
};

export function injectUserAttributes(span: Span): number {
  const user = getCurrentUser();
  if (!user) {
    return 0;
  }

  let injectedCount = 0;

  if (user.id) {
    span.setAttribute(CONV.USER_ID, user.id);
    injectedCount++;
  }
  if (user.name) {
    span.setAttribute(CONV.USER_NAME, user.name);
    injectedCount++;
  }
  if (user.fullName) {
    span.setAttribute(CONV.USER_FULL_NAME, user.fullName);
    injectedCount++;
  }
  if (user.email) {
    span.setAttribute(CONV.USER_EMAIL, user.email);
    injectedCount++;
  }
  if (user.roles && user.roles.length) {
    span.setAttribute(CONV.USER_ROLES, JSON.stringify(user.roles));
    injectedCount++;
  }

  if (injectedCount > 0) {
    emitSessionAttributeLog("[L9RUM Sessions] Injected user attributes on span", {
      "l9rum.session.span_name": (span as any).name,
      "l9rum.session.injected_count": injectedCount,
    });
  }

  return injectedCount;
}

export function injectSessionAttributes(span: Span): number {
  let injectedCount = 0;

  const sessionId = getCurrentSessionId();
  if (sessionId) {
    span.setAttribute(CONV.SESSION_ID, sessionId);
    emitSessionAttributeLog("[L9RUM Sessions] Injected session.id on span", {
      "l9rum.session.id": sessionId,
      "l9rum.session.span_name": (span as any).name,
    });
    injectedCount++;
  }

  const prevId = getPreviousSessionId();
  if (prevId) {
    span.setAttribute(CONV.SESSION_PREVIOUS_ID, prevId);
    emitSessionAttributeLog("[L9RUM Sessions] Injected session.previous_id on span", {
      "l9rum.session.previous_id": prevId,
      "l9rum.session.span_name": (span as any).name,
    });
    injectedCount++;
  }

  return injectedCount;
}
